import backdrop from "../pics/backdrop.jpg"
import github from "../pics/github.svg"
import me from "../pics/face.jpg"
// import go from "../pics/go.svg" 
//import typescript from "../pics/typescript.svg"


export function Body() {


  return (
    <>
      <div id="backdrop" className="relative flex justify-center text-nowrap" >
        <img src={backdrop} alt="backdrop" className="absolute -md:scal-3 h-screen w-screen" />
        <div id="header" className=" bg-white/2 backdrop-blur-lg rounded-lg mask-b-from-7 text-white text-[45px]  ">Brady Mcafee</div>
      </div>
      <div id="container" className="relative flex justify-center h-screen _moseyvgysfzmgoj1feag39blirnjk18">
        <div id="link" className=" w-100 items-center text-[35px] text-white text-center">

          <img src={me} alt="Github" className=" ml-24 w-45 h-70  rounded-[40] " />
          <article className="  opacity-69 mt-12 bg-gray-300 rounded-lg text-[22px] text-black ">

            “An investment in knowledge pays the best interest.” - Benjamin Franklin</article>
          <a href="https://github.com/brady90"><img
            src={github}
            className="ml-34 mt-25 h-20 w-20 hover:scale-150"
          ></img></a>
        </div >

        <div id="grid" className=" absolute bottom-19  grid gap-20  grid-cols-3 ">
        </div>
      </div >
    </>
  )
}
export default Body
